import { Navigate, useParams, type RouteObject } from 'react-router';
import { page } from '@/lib/lazy-route';

const recruitment = () => import('./recruitment-page');

function StatutoryPayRedirect() {
  const { id } = useParams();
  return <Navigate to={id ? `/payroll/statutory-pay/${id}` : '/payroll/statutory-pay'} replace />;
}

// HR (Sage HR) and My Space self-service. Owned by the hr module.
export const routes: RouteObject[] = [
  {
    path: 'hr',
    lazy: page(() => import('./hr-layout'), (m) => m.HrLayout),
    children: [
      { index: true, lazy: page(() => import('./hr-overview-page'), (m) => m.HrOverviewPage) }, // P2-7 (N12)
      { path: 'people', lazy: page(() => import('./people-page'), (m) => m.PeoplePage) },
      { path: 'people/:id', lazy: page(() => import('./employee-profile'), (m) => m.EmployeeProfilePage) },
      { path: 'leave', lazy: page(() => import('./leave-page'), (m) => m.LeavePage) },
      { path: 'timesheets', lazy: page(() => import('./timesheets-page'), (m) => m.TimesheetsPage) },
      { path: 'performance', lazy: page(() => import('./performance-page'), (m) => m.PerformancePage) },
      { path: 'onboarding', lazy: page(() => import('./onboarding-page'), (m) => m.OnboardingPage) },
      { path: 'documents', lazy: page(() => import('./documents-page'), (m) => m.DocumentsPage) },
      { path: 'recruitment', lazy: page(recruitment, (m) => m.RecruitmentPage) },
      { path: 'recruitment/:jobId', lazy: page(recruitment, (m) => m.JobPipelinePage) },
      { path: 'expenses', lazy: page(() => import('./expenses-page'), (m) => m.ExpensesPage) },
      // Phase E (people track)
      { path: 'sickness', lazy: page(() => import('./sickness-page'), (m) => m.SicknessPage) },
      { path: 'right-to-work', lazy: page(() => import('./right-to-work-page'), (m) => m.RightToWorkPage) },
      { path: 'rota', lazy: page(() => import('./rota-page'), (m) => m.RotaPage) },
      { path: 'attendance', lazy: page(() => import('./attendance-page'), (m) => m.AttendancePage) },
      { path: 'signatures', lazy: page(() => import('./signatures-page'), (m) => m.SignaturesPage) },
      { path: 'reports', lazy: page(() => import('./reports-page'), (m) => m.HrReportsPage) },
      { path: 'settings', lazy: page(() => import('./settings-page'), (m) => m.SettingsPage) },
      // Phase H (H-C). P2-4 (A10): Statutory pay is Payroll → Statutory pay; old links redirect.
      { path: 'statutory-pay/:id?', element: <StatutoryPayRedirect /> },
    ],
  },
  {
    path: 'me',
    lazy: page(() => import('./me/me-layout'), (m) => m.MeLayout),
    children: [
      { index: true, lazy: page(() => import('./me/me-overview'), (m) => m.MeOverviewPage) },
      { path: 'profile', lazy: page(() => import('./me/me-profile'), (m) => m.MeProfilePage) },
      { path: 'leave', lazy: page(() => import('./me/me-leave'), (m) => m.MeLeavePage) },
      { path: 'timesheets', lazy: page(() => import('./me/me-timesheets'), (m) => m.MeTimesheetsPage) },
      { path: 'performance', lazy: page(() => import('./me/me-performance'), (m) => m.MePerformancePage) },
      { path: 'documents', lazy: page(() => import('./me/me-documents'), (m) => m.MeDocumentsPage) },
      { path: 'expenses', lazy: page(() => import('./me/me-expenses'), (m) => m.MeExpensesPage) },
      { path: 'approvals', lazy: page(() => import('./me/me-approvals'), (m) => m.MeApprovalsPage) },
      { path: 'team', lazy: page(() => import('./me/me-team'), (m) => m.MeTeamPage) }, // P2-7: My team
      // Phase E (people track)
      { path: 'shifts', lazy: page(() => import('./me/me-shifts'), (m) => m.MeShiftsPage) },
      { path: 'signatures', lazy: page(() => import('./me/me-signatures'), (m) => m.MeSignaturesPage) },
      { path: 'signatures/:id', lazy: page(() => import('./me/me-sign'), (m) => m.MeSignPage) },
      // Phase H (H-B): the starter checklist (payslips follow in H-G)
      { path: 'payroll', lazy: page(() => import('@/modules/payroll/me-payroll'), (m) => m.MePayrollPage) },
    ],
  },
];
export const orgRoutes: RouteObject[] = [];
